import React from 'react';
import { AuthProvider } from 'react-oidc-context';
import { oidcUserManager, isOidcEnabled } from '@/auth/oidcClient';

const handleSigninCallback = () => {
  if (typeof window === 'undefined') {
    return;
  }
  window.history.replaceState({}, document.title, window.location.pathname);
};

export const OidcProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  if (!isOidcEnabled() || !oidcUserManager) {
    return <>{children}</>;
  }

  return (
    <AuthProvider userManager={oidcUserManager} onSigninCallback={handleSigninCallback}>
      {children}
    </AuthProvider>
  );
};
